const BlankPage = () => {
    return <h1 className="blank-page-title">작업중입니다</h1>;
};

export default BlankPage;
